var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaged(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69274 5.64553H12.2653V15H14.9581V3.49211L7.26579 0L0 3.49211V15H2.69274V5.64553Z",
    fill: "#E16C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26579 13.1757H5.56724V14.6409H7.26579V13.1757Z",
    fill: "#E16C00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35048 13.1757H7.65194V14.6409H9.35048V13.1757Z",
    fill: "#E16C00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18135 13.1757H3.4828V14.6409H5.18135V13.1757Z",
    fill: "#E16C00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26579 11.1658H5.56724V12.6311H7.26579V11.1658Z",
    fill: "#E16C00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18135 11.1658H3.4828V12.6311H5.18135V11.1658Z",
    fill: "#E16C00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35048 11.1658H7.65194V12.6311H9.35048V11.1658Z",
    fill: "#E16C00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26579 9.15622H5.56724V10.6215H7.26579V9.15622Z",
    fill: "#E16C00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18135 9.15622H3.4828V10.6215H5.18135V9.15622Z",
    fill: "#E16C00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4349 13.1757H9.73637V14.6409H11.4349V13.1757Z",
    fill: "#E16C00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaged);
export default __webpack_public_path__ + "static/media/staged.a0d24341.svg";
export { ForwardRef as ReactComponent };